var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({tag:"component"},'component',_vm.properties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }